export default {
  tasksReward: 'Görev Ödülü',
  lastWeekReward: 'Geçen Hafta Ödülü',
  thisWeekReward: 'Bu Hafta Ödülü',
};
